import { Link, MenuItem } from '@mui/material';
import React from 'react';

const LinkMenuHeader = (props) => {
  const { RouterLink, handleClose, uri, name, disabled } = props;
  return (
    <Link
      level="body1"
      underline="none"
      variant="solid"
      color="primary"
      component={RouterLink}
      to={disabled ? undefined : uri}
    >
      <MenuItem onClick={handleClose} disabled={disabled}>
        {name}
      </MenuItem>
    </Link>
  );
};

export default LinkMenuHeader;
